<div class="content-wrapper" id="div_content-wrapper_1e68e90f">
  <h2 aria-label="Lease Details" title="Lease Details" id="h2_4a55c236">
    Lease Details
  </h2>

  <p
    aria-label="Please provide your preferred lease details"
    title="Please provide your preferred lease details"
    class="text-secondary mb-4 text-color"
    id="p_text-secondary_bbdcb2d8"
  >
    Please provide your preferred lease details below to continue your quote
    request.
  </p>

  <div class="form-card" id="div_form-card_6a3e86e3">
    <form *ngIf="leaseOptions" [formGroup]="frmLeaseTerm" id="form_27e51b60">
      <!--LEASE TYPE-->
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="row-spacing"
        id="div_row-spacing_808abe06"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader title-align"
          id="div_lease-card-subheader_537cf803"
        >
          What is your preferred lease type?
        </div>

        <div
          fxFlex="40"
          fxLayout="column"
          fxLayoutAlign="start space-evenly"
          id="div_cd6b0f9f"
        >
          <div
            *ngFor="
              let option of leaseOptions['preferred-lease-type'];
              let first = first
            "
            class="field-checkbox"
            id="div_field-checkbox_91452e37"
          >
            <p-checkbox
              class="checkbox-option"
              [class.first]="first"
              [formControl]="
                $any(frmLeaseTerm).controls['preferred-lease-type']
              "
              [value]="option"
              value="option"
              [inputId]="option.id"
              name="preferred-lease-type"
              (onChange)="onchangeleaseOptions($event)"
              [label]="option.name"
              id="p-checkbox_checkbox-option_6bde2d72"
            ></p-checkbox>
          </div>

          <div
            *ngIf="
              frmLeaseTerm.controls['preferred-lease-type'].invalid &&
              (frmLeaseTerm.controls['preferred-lease-type'].dirty ||
                frmLeaseTerm.controls['preferred-lease-type'].touched)
            "
            class="error-text"
            id="div_error-text_1c76347f"
          >
            <div
              *ngIf="
                frmLeaseTerm.controls['preferred-lease-type'].errors?.[
                  'required'
                ]
              "
              id="div_c0bbac71"
            >
              Required field.
            </div>
          </div>
        </div>
      </div>

      <!--LEASE TERM-->
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="row-spacing"
        id="div_row-spacing_175536d5"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader title-align"
          id="div_lease-card-subheader_211b70b1"
        >
          What is your preferred lease term?
        </div>

        <div
          fxFlex="40"
          fxLayout="column"
          fxLayoutAlign="start space-evenly"
          id="div_1ca22b8f"
        >
          <div
            *ngFor="
              let option of leaseOptions['preferred-lease-term'];
              let first = first
            "
            class="field-checkbox"
            id="div_field-checkbox_bd4703d5"
          >
            <p-checkbox
              class="checkbox-option"
              [class.text-danger]="
                frmLeaseTerm.controls['preferred-lease-term'].invalid
              "
              [class.first]="first"
              value="option"
              [class.error-label]="
                frmLeaseTerm.controls['preferred-lease-term'].invalid &&
                (frmLeaseTerm.controls['preferred-lease-term'].dirty ||
                  frmLeaseTerm.controls['preferred-lease-term'].touched)
              "
              [value]="option"
              [formControl]="
                $any(frmLeaseTerm).controls['preferred-lease-term']
              "
              (onChange)="onchangeLeaseTerm($event)"
              [inputId]="option.id"
              name="preferred-lease-term"
              [label]="option.name"
              id="p-checkbox_checkbox-option_7bbe6cd5"
            >
            </p-checkbox>
          </div>

          <div
            *ngIf="
              frmLeaseTerm.controls['preferred-lease-term'].invalid &&
              (frmLeaseTerm.controls['preferred-lease-term'].dirty ||
                frmLeaseTerm.controls['preferred-lease-term'].touched)
            "
            class="error-text"
            id="div_error-text_9dce0cde"
          >
            <div
              *ngIf="
                frmLeaseTerm.controls['preferred-lease-term'].errors?.[
                  'required'
                ]
              "
              id="div_da62e143"
            >
              Required field.
            </div>
          </div>

          <div
            *ngIf="
              frmLeaseTerm.controls['preferred-lease-term'].invalid &&
              frmLeaseTerm.controls['preferred-lease-term'].untouched
            "
            class="required-text"
            id="div_required-text_7199d74b"
          >
            <div
              *ngIf="
                frmLeaseTerm.controls['preferred-lease-term'].errors?.[
                  'required'
                ]
              "
              id="div_b6232429"
            >
              Required field.
            </div>
          </div>

          <span
            class="p-float-label"
            style="margin-top: 16px"
            *ngIf="showleaseTermOther"
            id="span_p-float-label_4c673a5c"
          >
            <input
              id="leaseTermOther"
              formControlName="preferred-lease-term-other"
              #leaseTermOthr=""
              type="text"
              pInputText=""
              name="preferred-lease-term-other"
              maxlength="55"
              ngDefaultControl=""
            />

            <label
              for="leaseTermOther"
              [class.red-label]="
                frmLeaseTerm.controls['preferred-lease-term-other'].hasError(
                  'pattern'
                )
              "
              id="label_5c85683d"
              >Enter Text
            </label>

            <span id="span_030336ba">{{ leaseTermOthr.value?.length }}/55</span>
          </span>
        </div>
      </div>

      <!--RAILCARS NEEDED-->
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="row-spacing"
        id="div_row-spacing_15bd6306"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader title-align"
          id="div_lease-card-subheader_4fad5c4d"
        >
          How many railcars do you need?
        </div>

        <div
          fxFlex="40"
          fxLayout="row"
          fxLayoutGap="16px"
          fxLayoutAlign="start start"
          id="div_292ef180"
        >
          <!--MIN-->
          <div
            style="width: 50%"
            [class.error-label]="
              frmLeaseTerm.controls['min'].invalid &&
              (frmLeaseTerm.controls['min'].dirty ||
                frmLeaseTerm.controls['min'].touched)
            "
            id="div_608a7701"
          >
            <span class="p-float-label always" id="span_p-float-label_2e68dba8">
              <input
                placeholder="Enter Min"
                formControlName="min"
                [max]="getMax()"
                id="min"
                type="number"
                min="1"
                pInputText=""
                name="min"
                ngDefaultControl=""
              />

              <label for="min" id="label_283925af">Min </label>
            </span>

            <div class="error-text dropdown" id="div_error-text_0d4ab2e3">
              <div
                *ngIf="
                  frmLeaseTerm.controls['min'].invalid &&
                  (frmLeaseTerm.controls['min'].dirty ||
                    frmLeaseTerm.controls['min'].touched) &&
                  frmLeaseTerm.controls['min'].errors?.['required']
                "
                id="div_a397c848"
              >
                Required field.
              </div>
            </div>

            <div
              class="required-text"
              *ngIf="
                frmLeaseTerm.controls['min'].invalid &&
                frmLeaseTerm.controls['min'].untouched
              "
              id="div_required-text_6c20902f"
            >
              Required field.
            </div>
          </div>

          <!--MAX-->
          <div
            style="width: 50%"
            [class.error-label]="
              frmLeaseTerm.controls['max'].invalid &&
              (frmLeaseTerm.controls['max'].dirty ||
                frmLeaseTerm.controls['max'].touched)
            "
            id="div_dd8712d1"
          >
            <span class="p-float-label always" id="span_p-float-label_dfb4ddec">
              <input
                placeholder="Enter Max"
                formControlName="max"
                id="max"
                type="number"
                maxlength="6"
                [min]="getMin()"
                pInputText=""
                name="max"
                ngDefaultControl=""
              />

              <label for="max" id="label_8962b38b">Max </label>
            </span>

            <div class="error-text dropdown" id="div_error-text_0baf85a7">
              <div
                *ngIf="
                  frmLeaseTerm.controls['max'].invalid &&
                  (frmLeaseTerm.controls['max'].dirty ||
                    frmLeaseTerm.controls['max'].touched) &&
                  frmLeaseTerm.controls['max'].errors?.['required']
                "
                id="div_2692e132"
              >
                Required field.
              </div>
            </div>

            <div
              class="required-text"
              *ngIf="
                frmLeaseTerm.controls['max'].invalid &&
                frmLeaseTerm.controls['max'].untouched
              "
              id="div_required-text_4cfb7385"
            >
              Required field.
            </div>
          </div>
        </div>
      </div>

      <!--FIRST LOADING LOCATION-->
      <div
        fxLayout="row"
        fxLayoutAlign="start start"
        class="row-spacing"
        id="div_row-spacing_b0843116"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader title-align"
          id="div_lease-card-subheader_5a1a174b"
        >
          Where is your first loading location?
        </div>

        <div
          style="margin-top: -18px"
          fxFlex="40"
          fxLayout="column"
          fxLayoutAlign="start stretch"
          fxLayoutGap="28px"
          id="div_c75c0c5c"
        >
          <div id="div_28b0a48a">
            <span class="p-float-label" id="span_p-float-label_b0d2d53e">
              <p-dropdown
                [options]="countries"
                name="country"
                ngDefaultControl=""
                formControlName="country"
                [class.error-label]="
                  frmLeaseTerm.controls['country'].invalid &&
                  (frmLeaseTerm.controls['country'].dirty ||
                    frmLeaseTerm.controls['country'].touched)
                "
                [ngClass]="{
                  selected:
                    frmLeaseTerm.value.country != '' &&
                    frmLeaseTerm.value.country != null
                }"
                optionValue="name"
                optionLabel="name"
                placeholder="Country"
                (onChange)="changeCountry()"
                id="p-dropdown_8c1bd302"
              >
                <ng-template
                  let-item=""
                  pTemplate="item"
                  id="ng-template_cb4a3241"
                >
                  <div id="div_455ef07f">{{ item.name }}</div>
                </ng-template>
              </p-dropdown>

              <div
                *ngIf="
                  frmLeaseTerm.controls['country'].invalid &&
                  (frmLeaseTerm.controls['country'].dirty ||
                    frmLeaseTerm.controls['country'].touched)
                "
                class="error-text dropdown"
                id="div_error-text_f09fa283"
              >
                <div
                  *ngIf="frmLeaseTerm.controls['country'].errors?.['required']"
                  id="div_6241c39a"
                >
                  Required field.
                </div>
              </div>

              <div
                *ngIf="
                  frmLeaseTerm.controls['country'].invalid &&
                  frmLeaseTerm.controls['country'].untouched
                "
                class="required-text dropdown"
                id="div_required-text_1b5562ac"
              >
                <div
                  *ngIf="frmLeaseTerm.controls['country'].errors?.['required']"
                  id="div_88af26ca"
                >
                  Required field.
                </div>
              </div>

              <label
                class="label-select"
                *ngIf="
                  frmLeaseTerm.value.country !== '' &&
                  frmLeaseTerm.value.country != null
                "
                id="label_label-select_8083006d"
                >Country</label
              >
            </span>
          </div>

          <div id="div_e3a90dd1">
            <span class="p-float-label" id="span_p-float-label_2557344e">
              <input
                id="city"
                type="text"
                pInputText=""
                name="city"
                formControlName="city"
                ngDefaultControl=""
                [ngClass]="{ filled: frmLeaseTerm.value.city != '' }"
              />
              <label for="city" id="label_bc37f846"
                >City <i id="i_272722d1">Optional</i></label
              >
            </span>
            <small
              class="p-error block"
              *ngIf="frmLeaseTerm.controls['city'].hasError('pattern')"
              id="small_p-error_ab77764d"
              >City is invalid.</small
            >
          </div>

          <div id="div_c8099025">
            <span class="p-float-label" id="span_p-float-label_b1850c7a">
              <p-dropdown
                [options]="
                  selectedCountryIndex !== -1
                    ? countries[selectedCountryIndex].states
                    : []
                "
                id="stateDropdown"
                ngDefaultControl=""
                name="state"
                formControlName="state"
                [ngClass]="{
                  selected:
                    frmLeaseTerm.value.state !== '' &&
                    frmLeaseTerm.value.state !== null
                }"
                optionValue="name"
                optionLabel="name"
                placeholder="State/Province Optional"
              >
                <ng-template
                  let-state=""
                  pTemplate="item"
                  id="ng-template_2fcadfed"
                >
                  <div id="div_1efaf0e7">{{ state.name }}</div>
                </ng-template>
              </p-dropdown>
              <label
                class="label-select"
                *ngIf="
                  frmLeaseTerm.value.state !== '' &&
                  frmLeaseTerm.value.state !== null
                "
                id="label_label-select_778193af"
                >State/Province <i id="i_2ce2cb36">Optional</i></label
              >
            </span>
          </div>
        </div>
      </div>

      <!--PREFERRED RAIL CARRIER-->
      <div
        fxLayout="row"
        fxLayoutAlign="start start"
        class="row-spacing"
        id="div_row-spacing_68392640"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader"
          id="div_lease-card-subheader_5ce6bd31"
        >
          What is your preferred rail carrier?
        </div>

        <div
          style="margin-top: -22px"
          fxFlex="40"
          fxLayout="column"
          fxLayoutAlign="start stretch"
          id="div_280b2d05"
        >
          <p-multiSelect
            placeholder="Select preferred rail carrier"
            styleClass="multi-select-pressure-cart"
            [showToggleAll]="false"
            optionLabel="name"
            filterPlaceHolder="Search..."
            [class.error-label]="
              frmLeaseTerm.controls['preferred-rail-carrier'].invalid &&
              (frmLeaseTerm.controls['preferred-rail-carrier'].dirty ||
                frmLeaseTerm.controls['preferred-rail-carrier'].touched)
            "
            [showClear]="false"
            [showHeader]="false"
            id="air-valve-type"
            formControlName="preferred-rail-carrier"
            [options]="carriers"
            (onChange)="carrierChange($event)"
          >
            <ng-template let-item="" pTemplate="item" id="ng-template_74e0a110">
              <div
                class="checkbox-container-row"
                id="div_checkbox-container-row_cb7b81e7"
              >
                <div id="div_a73f04b0">{{ item.name }}</div>
              </div>
            </ng-template>
          </p-multiSelect>

          <div
            *ngIf="
              frmLeaseTerm.controls['preferred-rail-carrier'].invalid &&
              (frmLeaseTerm.controls['preferred-rail-carrier'].dirty ||
                frmLeaseTerm.controls['preferred-rail-carrier'].touched)
            "
            class="error-text dropdown"
            id="div_error-text_e1a02bd3"
          >
            <div
              *ngIf="
                frmLeaseTerm.controls['preferred-rail-carrier'].errors?.[
                  'required'
                ]
              "
              id="div_cc0892e6"
            >
              Required field.
            </div>
          </div>

          <div
            *ngIf="
              frmLeaseTerm.controls['preferred-rail-carrier'].invalid &&
              frmLeaseTerm.controls['preferred-rail-carrier'].untouched
            "
            class="required-text"
            id="div_required-text_c63e360e"
          >
            <div
              *ngIf="
                frmLeaseTerm.controls['preferred-rail-carrier'].errors?.[
                  'required'
                ]
              "
              id="div_f9235c4d"
            >
              Required field.
            </div>
          </div>

          <!-- <div  style="margin-top: 12px !important;"></div> -->

          <div
            class="p-float-label"
            *ngIf="showCarrierOther"
            style="margin-top: 20px !important"
            id="div_p-float-label_5b3d8d67"
          >
            <input
              id="carrierOther"
              formControlName="preferred-rail-carrier-other"
              #carrierOthr=""
              type="text"
              pInputText=""
              name="carrierOther"
              maxlength="55"
              ngDefaultControl=""
            />

            <label
              for="carrierOther"
              [class.red-label]="
                frmLeaseTerm.controls['preferred-rail-carrier-other'].hasError(
                  'pattern'
                )
              "
              id="label_a8fad894"
              >Enter Text
            </label>

            <span id="span_392aa339">{{ carrierOthr.value?.length }}/55</span>
          </div>
        </div>
      </div>

      <!--RAIL SERVICE TYPE-->
      <div
        fxLayout="row"
        fxLayoutAlign="start start"
        class="row-spacing"
        id="div_row-spacing_e45df356"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader title-align"
          id="div_lease-card-subheader_f950c9db"
        >
          What is the type of rail service?
        </div>

        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          *ngFor="let option of leaseOptions['rail-service-type']"
          id="div_c2eb91e5"
        >
          <p-radioButton
            [ngStyle]="{ 'margin-right': '28px' }"
            class="radio-option"
            name="rail-service-type"
            formControlName="rail-service-type"
            value="option"
            [value]="option"
            [label]="option.name"
            id="p-radioButton_radio-option_0d4dfa9c"
          ></p-radioButton>
        </div>
      </div>

      <!--RAILCAR DATE-->
      <div
        fxLayout="row"
        fxLayoutAlign="start start"
        class="row-spacing"
        id="div_row-spacing_b6ed5094"
      >
        <div
          fxFlex="47"
          class="lease-card-subheader title-align"
          id="div_lease-card-subheader_6b070c2c"
        >
          When do you need these railcars?
        </div>

        <div style="margin-top: -22px" fxFlex="40" id="div_9922738d">
          <div id="div_1111d34b">
            <span class="p-float-label" id="span_p-float-label_98396600">
              <p-calendar
                name="leaseableDate"
                ngDefaultControl=""
                placeholder="Select Date"
                [class.error-label]="
                  frmLeaseTerm.controls['leaseableDate'].invalid &&
                  (frmLeaseTerm.controls['leaseableDate'].dirty ||
                    frmLeaseTerm.controls['leaseableDate'].touched)
                "
                formControlName="leaseableDate"
                [selectOtherMonths]="true"
                dateFormat="M d, yy"
                [readonlyInput]="true"
                styleClass="date-needed"
                [ngClass]="{ filled: frmLeaseTerm.value.leaseableDate != '' }"
                [minDate]="currentDate"
                [showIcon]="true"
                inputId="icon"
                id="p-calendar_9e22aa98"
              ></p-calendar>

              <label
                class="label-date"
                *ngIf="frmLeaseTerm.value.leaseableDate != ''"
                id="label_label-date_498d2cc8"
                >Date</label
              >
            </span>

            <div
              *ngIf="
                frmLeaseTerm.controls['leaseableDate'].invalid &&
                (frmLeaseTerm.controls['leaseableDate'].dirty ||
                  frmLeaseTerm.controls['leaseableDate'].touched)
              "
              class="error-text dropdown"
              id="div_error-text_7c3a5010"
            >
              <div
                *ngIf="
                  frmLeaseTerm.controls['leaseableDate'].errors?.['required']
                "
                id="div_9393cb7d"
              >
                Required field.
              </div>
            </div>

            <div
              *ngIf="
                frmLeaseTerm.controls['leaseableDate'].invalid &&
                frmLeaseTerm.controls['leaseableDate'].untouched
              "
              class="required-text"
              id="div_required-text_dc180f77"
            >
              <div
                *ngIf="
                  frmLeaseTerm.controls['leaseableDate'].errors?.['required']
                "
                id="div_a9446a39"
              >
                Required field.
              </div>
            </div>
          </div>

          <div class="small-checkbox" id="div_small-checkbox_452d5e6a">
            <p-checkbox
              label="Selected date is flexible"
              id="flexable-date"
              name="flexableDate"
              formControlName="flexableDate"
              [binary]="true"
            ></p-checkbox>
          </div>
        </div>
      </div>

      <!-- SDS file Table  -->
      <div class="mb-2" id="div_mb-2_04579272">
        <p-table [value]="sdsFileList" id="p-table_e3923a8f">
          <ng-template pTemplate="header" id="ng-template_970af67a">
            <tr id="tr_ae5a1512">
              <th id="th_ec736309">File Name</th>
              <th id="th_b76bd031">View</th>
              <th id="th_f3cc337f">Select</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-files="" id="ng-template_59f6a8eb">
            <tr id="tr_37e62542">
              <td id="td_f0fcf767">{{ files?.files?.file_name }}</td>
              <td id="td_4be7a94f">
                <a
                  aria-label="View"
                  title="View"
                  target="_blank"
                  href="{{
                    files?.files?.file_path?.split(
                      '?Content-Type=application'
                    )[0]
                  }}"
                  id="a_a0cbf146"
                  >View</a
                >
              </td>
              <td id="td_b68b2157">
                <div class="small-checkbox" id="div_small-checkbox_2df864f8">
                  <p-checkbox
                    [disabled]="checkDisable(files)"
                    name="selectfiles"
                    (onChange)="isSelect($event, files)"
                    [(ngModel)]="files.isChecked"
                    [ngModelOptions]="{ standalone: true }"
                    [binary]="true"
                    id="p-checkbox_f7084438"
                  ></p-checkbox>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!--DATA SHEET UPLOADER-->
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="row-spacing"
        id="div_row-spacing_98dd92ed"
      >
        <div class="upload-panel" id="div_upload-panel_441c0de7">
          <h4 class="upload-header" id="h4_upload-header_35020e1a">
            Please upload a current Safety Data Sheet (SDS).
          </h4>

          <p
            aria-label="An SDS is required for all tank cars and hazardous materials"
            title="An SDS is required for all tank cars and hazardous materials"
            class="f14"
            id="p_f14_9746a8e2"
          >
            An SDS is required for all tank cars and hazardous materials.
          </p>

          <div
            class="dnd-container"
            appDnd=""
            (fileDropped)="onFileDropped($event)"
            id="div_dnd-container_04142f85"
          >
            <input
              class="cursor"
              type="file"
              #fileDropRef=""
              id="fileDropRef"
              (click)="canUploadSDSFile($event)"
              accept="application/pdf"
              (change)="fileBrowseHandler($event.target)"
            />

            <img
              alt="upload"
              aria-label="upload"
              title="upload"
              src="../../../../../assets/images/upload.webp"
              id="img_c00caab6"
            />
            <h4 id="h4_5fe76fd8">
              DRAG & DROP FILE OR <span id="span_d4ac7a71">BROWSE</span>
            </h4>
            <small for="fileDropRef" id="small_67247ea0"
              >Supported format: PDF</small
            >
          </div>
          <div class="files-list" id="div_files-list_41c6dc41">
            <div
              class="single-file"
              *ngFor="let file of files; let i = index"
              id="div_single-file_7bd6a828"
            >
              <div class="info" id="div_info_3e93f059">
                <h4
                  class="name"
                  title="{{ file?.sds_name }}"
                  id="h4_name_a79e305e"
                >
                  {{
                    file?.sds_name?.length > 40
                      ? (file?.sds_name | slice: 0 : 40) + '...'
                      : file?.sds_name
                  }}
                </h4>
              </div>

              <div
                class="delete"
                (click)="deleteFile(i, file)"
                id="div_delete_e1eeb681"
              >
                <i
                  class="pi pi-trash"
                  style="color: red"
                  id="i_pi_64ca4db2"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--ADDITIONAL INFORMATION-->
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="row-spacing"
        id="div_row-spacing_0578e724"
      >
        <div class="col-md-12 text-center" id="div_col-md-12_2ee60f62">
          <div class="addition" id="div_addition_b8ceb9fd">
            <h4 id="h4_df5291fd">Additional Information</h4>

            <p
              title=" Please list any other requirements"
              class="f14"
              id="p_f14_c21fae29"
            >
              Please list any other requirements or details you'd like us to
              know. If you have an additional spec sheet, please upload it
              above.
            </p>

            <textarea
              formControlName="comments"
              [maxLength]="250"
              rows="4"
              cols="30"
              placeholder="0/250 Characters"
              id="textarea_abec78db"
            ></textarea>

            <div
              class="form-check d-inline-block mt-3"
              id="div_form-check_24a8431b"
            >
              <p-checkbox
                [binary]="true"
                formControlName="trinSight"
                name="trinSight"
                id="trinSight"
                inputId="trinSight"
              ></p-checkbox>

              <label
                class="form-check-label"
                style="margin-left: 12px"
                for="trinSight"
                id="label_form-check-label_06726123"
              >
                I want to know more about Trinsight®.
              </label>
              <i
                (click)="displayTrinsightHelp = true"
                class="pi pi-info-circle prep-info-button"
                id="i_pi_3c58c782"
              ></i>
            </div>

            <div
              *ngIf="displayTrinsightHelp"
              class="dialog-tooltip-container"
              id="div_dialog-tooltip-container_df0eeda0"
            >
              <div class="dialog-tooltip" id="div_dialog-tooltip_9bde5155">
                <div class="dialog-title" id="div_dialog-title_849b592b">
                  Trinsight®
                </div>

                <div
                  class="dialog-paragraph"
                  id="div_dialog-paragraph_0d2bbd92"
                >
                  REAL-TIME VISIBILITY. RAIL-TIME EFFICIENCY.<br />
                  <br />
                  TrinityRail‘s Trinsight® is a next-gen digital platform that
                  monitors sensor-equipped cars and their freight in real time,
                  from origin to destination. The result: You protect your
                  freight, optimize your fleet, maximize working capital, and
                  streamline your supply chain.
                  <br />Learn more
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- <p-progressSpinner fxFlexAlign="center" *ngIf="!leaseOptions"></p-progressSpinner> -->
  </div>

  <!--PLACEHOLDER BUTTONS-->
  <div class="button-container" id="div_button-container_b322a93c">
    <button
      (click)="back()"
      class="back-button"
      pButton=""
      icon="pi pi-angle-left"
      id="button_back-button_2c5d8b02"
    ></button>

    <button
      class="quiz-button"
      [disabled]="!frmLeaseTerm.valid"
      pButton=""
      label="Next"
      (click)="next()"
      id="button_quiz-button_a4b3e445"
    ></button>
  </div>
</div>
<div
  class="info-help-dialog-click-overlay"
  (click)="displayTrinsightHelp = false"
  [hidden]="!displayTrinsightHelp"
  id="div_info-help-dialog-click-overlay_89d801d8"
></div>

<div
  class="progress-spinner"
  *ngIf="!leaseOptions"
  id="div_progress-spinner_ee4691fb"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_23496c1d"
  ></p-progressSpinner>
</div>
